export const programMap = {
  900215: 'Second Step® Bullying Prevention Unit Training',
  900315: 'Second Step® Child Protection Unit Training',
  910000: 'Second Step®',
  910001: 'Second Step® K8 Digital Well-Being',
  920000: 'Second Step® SEL for Adults',
}
